<template>
  <div style="display: flex; position: relative; flex-direction: column">
    <div v-if="tableTitle" class="tableTitle">
      <span class="tableTitle--text" v-html="tableTitle"></span>
    </div>
    <table
      :style="{
        ...scrollableTableStyle,
      }"
      style="table-layout: fixed; position: absolute; z-index: 5"
    >
      <tr
        v-for="(row, rowIndex) in stickyContent"
        :key="rowIndex"
        :id="stickyRowId(rowIndex)"
      >
        <td
          v-for="(cell, cellIndex) in row"
          :key="stickyCellId(cellIndex)"
          :id="stickyCellId(cellIndex)"
          :style="{
            ...scrollableTableCellStyle,
            ...cell.style,
            ...(cell.style.width ? { width: `${cell.style.width}px` } : {}),
            ...(!isStickyColumn(cellIndex)
              ? { width: 0, opacity: 0 }
              : { opacity: 1 }),
            backgroundColor: cell.style.backgroundColor,
            paddingTop: `${cell.style.paddingTop}px`,
            paddingBottom: `${cell.style.paddingBottom}px`,
            paddingRight: `${cell.style.paddingRight}px`,
            paddingLeft: `${cell.style.paddingLeft}px`,
          }"
        >
          <div v-html="cell.content"></div>
        </td>
      </tr>
    </table>
    <div style="overflow-x: scroll; padding-bottom: 20px">
      <table
        :style="{
          ...scrollableTableStyle,
        }"
        style="table-layout: fixed"
      >
        <tr
          v-for="(row, rowIndex) in tableContent"
          :id="rowId(rowIndex)"
          :key="rowIndex"
        >
          <template>
            <td
              v-for="(cell, cellIndex) in row"
              :key="`tableHeadPreviewCells_${cellIndex}`"
              :id="cellId(cellIndex)"
              :style="{
                ...scrollableTableCellStyle,
                ...cell.style,
                ...(cell.style.width
                  ? { minWidth: `${cell.style.width}px` }
                  : {}),
                backgroundColor: cell.style.backgroundColor,
                paddingTop: `${cell.style.paddingTop}px`,
                paddingBottom: `${cell.style.paddingBottom}px`,
                paddingRight: `${cell.style.paddingRight}px`,
                paddingLeft: `${cell.style.paddingLeft}px`,
                opacity: isStickyColumn(cellIndex) ? '0' : '1',
              }"
            >
              <div v-html="cell.content"></div>
            </td>
          </template>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HtmlTableItemPreview',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    tableTitle () {
      return this.item.itemableAttributes.tableTitle
    },
    tableContent () {
      return this.item.itemableAttributes.htmlTableContent
    },
    stickyContent () {
      return this.tableContent.map((row) =>
        row.filter((_, index) => this.isStickyColumn(index))
      )
    },
    scrollableTableStyle () {
      return this.item.itemableAttributes.scrollable
        ? { width: 'auto' }
        : { width: '100%' }
    },
    scrollableTableCellStyle () {
      return this.item.itemableAttributes.scrollable
        ? { minWidth: `${this.tdMinWidth}px` }
        : {}
    },
    tdMinWidth () {
      return 50
    }
  },
  mounted () {
    this.unifyStickyCellsSize()
  },
  methods: {
    isStickyColumn (index) {
      return (
        this.item.itemableAttributes.scrollable &&
        this.item.itemableAttributes.tableColumnFixed >= index
      )
    },
    unifyStickyCellsSize () {
      this.tableContent.map((_, index) => {
        const stickyRow = document.getElementById(this.stickyRowId(index))
        const row = document.getElementById(this.rowId(index))
        const maxRowHeight = `${Math.max(
          stickyRow.clientHeight,
          row.clientHeight
        )}px`
        stickyRow.style.height = maxRowHeight
        row.style.height = maxRowHeight
      })
      this.stickyContent.map((row) =>
        row.map((_, index) => {
          const stickyCell = document.getElementById(this.stickyCellId(index))
          const cell = document.getElementById(this.cellId(index))
          stickyCell.style.width = `${cell.clientWidth}px`
        })
      )
    },
    stickyCellId (index) {
      return `tableStickyCells_${this.item.uuid}_${index}`
    },
    cellId (index) {
      return `tableCells_${this.item.uuid}_${index}`
    },
    stickyRowId (index) {
      return `tableHeadPreviewStickyRow_${this.item.uuid}_${index}`
    },
    rowId (index) {
      return `tableHeadPreviewRow_${this.item.uuid}_${index}`
    }
  }
}
</script>

<style scoped>
.tableTitle {
  text-align: center;
  margin-bottom: 12px;
  font-weight: bold;
}
.tableTitle--text {
  border-bottom: 1px solid #f37f77;
  padding-bottom: 0.2em;
}
table,
th,
td {
  border: 1px solid #aaa;
}

table {
  overflow-x: auto;
  border-spacing: 0;
}

tbody {
  white-space: nowrap;
}

th,
td {
  padding: 1px;
  vertical-align: middle;
  border-top-width: 0;
  border-left-width: 0;
}

th:last-child,
td:last-child {
  border-right-width: 0;
}

tr:last-child td {
  border-bottom-width: 0;
}

.sticky {
  position: sticky !important;
}
</style>
